import { JSX } from 'react';
import { Box } from '@mui/material';
import { BackstoryQuery } from 'components/BackstoryQuery';
import { Candidate, CandidateQuestion, Resume } from 'types/types';

function SuggestedQuestions({
  resume,
  selectedCandidate,
  defaultQuestions,
  isMobile,
  onSubmitQuestion,
}: {
  resume: Resume | null;
  selectedCandidate: Candidate;
  defaultQuestions: string[];
  isMobile: boolean;
  onSubmitQuestion: (question: CandidateQuestion) => void;
}): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 0.5,
        p: isMobile ? '4px 8px' : 0.5,
        flex: 0,
        flexShrink: 0,
        height: isMobile ? 68 : undefined,
        maxHeight: isMobile ? 68 : undefined,
        alignItems: isMobile ? 'stretch' : undefined,
        position: 'relative',
        zIndex: isMobile ? 2 : undefined,
        backgroundColor: 'background.paper',
        flexWrap: 'wrap',
        overflowX: 'visible',
        overflowY: isMobile ? 'auto' : 'visible',
        borderTop: isMobile ? '1px solid rgba(0, 0, 0, 0.08)' : undefined,
        scrollbarWidth: isMobile ? 'thin' : undefined,
        '&::-webkit-scrollbar': { width: isMobile ? 4 : undefined },
        '& .MuiButton-root': isMobile
          ? {
              flex: '1 1 calc(50% - 4px)',
              minWidth: 0,
              maxWidth: '100%',
              minHeight: 26,
              maxHeight: 56,
              px: 0.75,
              py: 0.15,
              borderRadius: '10px',
              fontSize: '0.62rem',
              lineHeight: 1.1,
              textAlign: 'left',
              whiteSpace: 'normal',
              textTransform: 'none',
              overflowWrap: 'anywhere',
            }
          : undefined,
      }}
    >
      {resume &&
        defaultQuestions.map((question, i) => (
          <BackstoryQuery key={i} question={{ question }} submitQuery={onSubmitQuestion} />
        ))}
      {selectedCandidate.questions?.map((q, i) => (
        <BackstoryQuery key={i} question={q} submitQuery={onSubmitQuestion} />
      ))}
    </Box>
  );
}

export { SuggestedQuestions };
